import { getGroupWiseAccountsCount } from "../types/admin_analytics_types";

const initState = {
  data: [],
  loading: false,
  error: null,
};

export default function groupWiseAccountsCountReducer(state = initState, action = {}) {
  switch (action.type) {
    case getGroupWiseAccountsCount.GET_GROUP_WISE_ACCOUNTS_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getGroupWiseAccountsCount.GET_GROUP_WISE_ACCOUNTS_COUNT_SUCCESS:
        console.log("GET_GROUP_WISE_ACCOUNTS_COUNT_SUCCESS" , action.payload)
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null,
      };
    case getGroupWiseAccountsCount.GET_GROUP_WISE_ACCOUNTS_COUNT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
